import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";
import {Box} from "@mui/material";

import ProductImage from "./ProductImage";

import {blue500, greyishBlue500} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

TopProductCell.propTypes = {
    id: PropTypes.string,
    image: PropTypes.string,
    sku: PropTypes.string,
    sales: PropTypes.number,
    retailerId: PropTypes.string,
    bottomContent: PropTypes.any
};

function TopProductCell({image, sku, bottomContent = null, retailerId, id}) {
    const history = useHistory();

    return (
        <Box
            onClick={(e) => {
                e.stopPropagation();
                navigateOnClick(e, MarketplaceRoutes.RETAILER_PRODUCT(retailerId, id), history);
            }}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flexShrink: 0,
                width: "72px",
            }}
        >
            <ProductImage image={image} name={sku ?? ""} />
            <span style={{
                display: "block",
                width: "100%",
                fontSize: "10px",
                color: greyishBlue500,
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                lineHeight: 'normal'
            }}>
                {sku ?? ""}
            </span>
            {bottomContent && (
                <span style={{
                    display: "block",
                    width: "100%",
                    fontSize: "10px",
                    color: blue500,
                    textAlign: "center",
                    lineHeight: 'normal'
                }}>
                    {bottomContent}
                </span>
            )}
        </Box>
    );
}

export default TopProductCell;
